// from ActivateAccountState to LoggedOutState
// from LoggedInState to LoggedInState

// // create a widget that transforms auth state from LoggedOutState to one of
// // LoggedInState
// // LoggedOutState (i.e. if user goes to reset their password, they remain logged out, and this is the inital state for the reset password widget) 

// Internal State:
// LoginTwoFactor
// ResendActivationState
import i18next from "i18next";
import { Updater, Widget, any, nothing, wait } from 'widgets-for-react';
import { Pages } from "../../site/root/routes/routesState";
import { activateAccountSuccess, activateAccountWidget, activateAndChangePasswordForm, activate_account_failed } from "./activate_account_form";
import { Api, activate_account, activate_and_change_password, } from "./api_to_state";
import { AuthState, isActivateAccountState } from "./authState";
import { resendActivateAccount } from "./resend_activate_account";
import { options } from "./utils";
import { CurrentPage } from "../../utils/routes";

export function activateAccount(
  options: options,
  api: Api,
  s0: AuthState,
  params: CurrentPage<{ activateAcount: Pages["activateAccount"]}>["params"]
): Widget<Updater<AuthState>> {
    const email = params.userEmail || '';
    const token = params.activationToken || '';
    const originPath = params.originPath || '/';
    const reset = params.reset === 'true' // could this be part of the token?
    if (isActivateAccountState(s0)) {
      return any<Updater<AuthState>>([
        (s0.activateAccountState == "activate account" && reset) || s0.activateAccountState == "activate account - change password" || s0.activateAccountState == "activate account - error weak password" ?
          activateAndChangePasswordForm(options, s0, false, email, api) :
        s0.activateAccountState == "activate account - error token expired"?  
          resendActivateAccount(options, api, email, s0, i18next.t('auth:activateResendTokenExpired')) :
        s0.activateAccountState == "activate account - error account activation failed" ?
          activate_account_failed(options):
        s0.activateAccountState == "activate account" ?
          activateAccountWidget:
        s0.activateAccountState == "activate account - api error" ?
          any<Updater<AuthState>>([
            wait(500, { key: "login-widget-activate-account-promise" })(() => (s:AuthState) : AuthState => isActivateAccountState(s) && s.activateAccountState != "activate account - api error" ? s : ({ ...s, activateAccountState: "activate account - activating" })),
            activateAccountWidget
          ]) : 
        s0.activateAccountState == "activate account - activating" ?
          any<Updater<AuthState>>([
            activate_account(api, {...s0.activateAccountData, email, token }),
            activateAccountWidget
          ]) : 
        s0.activateAccountState == "activate account - account activated" ?
          activateAccountSuccess(originPath, options):
        s0.activateAccountState == "activate account - changing password" ?
          any([
            activate_and_change_password(api, {...s0.activateAccountData, email, token }),
            activateAndChangePasswordForm(options, s0, true, email, api),
          ]) :
        nothing()
      ])
    }
    else {
      return nothing()
    }
  }

// intermediate state
// ChangePasswordState